module.exports = __webpack_public_path__ + "img/requiredIcon.a7e4958c.svg";